import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: modules.auth,
    user: modules.user,
    payment: modules.payment,
    plan: modules.plan,
    point: modules.point,
    ticket: modules.ticket,
    contract: modules.contract,
    tenant: modules.tenant
  }
});

export default store;
